"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabsContext = void 0;
var _react = require("react");
var TabsContext = /*#__PURE__*/(0, _react.createContext)({});
exports.TabsContext = TabsContext;